import { render, staticRenderFns } from "./navBarLayout.vue?vue&type=template&id=4bd9c468&scoped=true&"
import script from "./navBarLayout.vue?vue&type=script&lang=ts&setup=true&"
export * from "./navBarLayout.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./navBarLayout.vue?vue&type=style&index=0&id=4bd9c468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd9c468",
  null
  
)

export default component.exports